/**
 * M7 S39: the commit confirmation (the move's cost lines, where it is staged, that the act is final) and, after it,
 * the Wire epilogue preview with each item's outlet. Every rule is in `models/finale.ts`. UI events only.
 */
import type { ReactNode } from 'react'
import type { FinaleView } from './models/finale'
import { FinaleButtons } from './RollCall'

export interface CommitProps {
  view: FinaleView
  row: number
  onPress: (index: number) => void
}

export function Commit(p: CommitProps): ReactNode {
  const v = p.view
  return (
    <div data-testid={v.step === 'done' ? 'finale-epilogue' : 'finale-confirm'}>
      {v.heading === null ? null : <h3 className="lg-section__title">{v.heading}</h3>}
      {v.lines.map((line) => (
        <p key={line} className="lg-line" data-testid="finale-cost">
          {line}
        </p>
      ))}
      {v.wire.length === 0 ? null : (
        <ul className="lg-list">
          {v.wire.map((w) => (
            <li key={w.headline} className="lg-row" data-testid="finale-wire">
              <span className="lg-row__meta">{w.outlet}</span> {w.headline}
            </li>
          ))}
        </ul>
      )}
      <FinaleButtons buttons={v.buttons} row={p.row} onPress={p.onPress} />
    </div>
  )
}
